module.exports = __webpack_public_path__ + "img/toke.69dcd716.svg";